<script setup>
import moment from 'moment';
import { ref, watch, computed, onMounted } from 'vue';

import { usePeriodStore } from '../../../../../store/periodStore';
import { useShipmentStore } from '../../../../../store/shipmentStore';

import SwitchInput from '@/components/ui/inputs/SwitchInput.vue';

const periodStore = usePeriodStore();
const shipmentStore = useShipmentStore();

const isDelivery = ref(false);
watch(isDelivery, (newVal) => {
    if (newVal) {
        shipmentStore.shipment_type = 'delivery';
        shipmentStore.clearPickupData();
    } else {
        shipmentStore.shipment_type = 'pickup';
        shipmentStore.clearDeliveryData();
        shipmentStore.setDefaultPickupLocation();
    }
});

const isDeliveryDisabled = computed(() => {
    const today = moment().startOf("day");
    let value = false;

    periodStore.periods.forEach(period => {
        const startDate = moment(period.startDate);
        const diffDays = today.diff(startDate, "days");
        if (Math.abs(diffDays) < 5) {
            value = true;
        }
    });

    return value;
});

onMounted(() => {
    if (shipmentStore.shipment_type === 'delivery') {
        isDelivery.value = true;
        shipmentStore.clearPickupData();
    } else {
        isDelivery.value = false;
        shipmentStore.clearDeliveryData();
    }
});
</script>

<template>
    <div>
        <SwitchInput 
            v-model="isDelivery" 
            :disabled="isDeliveryDisabled"
            :placeholder="$t('order.deliver')" 
        />

        <div
            v-if="isDeliveryDisabled"
            class="bg-white mt-4 p-4 rounded text-sm text-gray-700 border-2 border-sky-300"
        >
            <span
                v-if="isDeliveryDisabled"
                class="purchase-rent-shipment__delivery-note"
            >
                Delivery is unavailable on your selected start date. <br />
                Please allow a minimum of 2 business days for delivery.
            </span>
        </div>
    </div>
</template>